import { createStore, Store, StoreActionApi } from 'react-sweet-state';

import { OrgContext } from './types';

const initialState: OrgContext = {
	orgId: '',
	cloudIds: [],
	workspaceIds: [],
	workspaceUuids: [],
};

// This is exported from this file so it can be used in mocks.ts and store.ts. It should not be entirely exposed outside of this package
export const orgContextStore: Store<
	OrgContext,
	{
		setOrgContext: (orgContext: OrgContext) => ({ setState }: StoreActionApi<OrgContext>) => void;
	}
> = createStore({
	initialState,
	actions: {
		setOrgContext:
			(orgContext: OrgContext): (({ setState }: StoreActionApi<OrgContext>) => void) =>
			({ setState }) => {
				setState(orgContext);
			},
	},
	name: 'org-context-store',
});
